import { Card, Flex, Typography } from "antd";
import Chart from "react-apexcharts";
import React from "react";

export default function FinancialScore() {
  const financialScoreOptions = {
    chart: {
      type: "donut",
      height: 250,
    },
    labels: ["Score", "Remaining"],
    colors: ["#52c41a", "#E0DDF7"],
    legend: {
      show: false,
    },
    dataLabels: {
      enabled: false,
    },
    plotOptions: {
      pie: {
        startAngle: -180,
        endAngle: 180,
        donut: {
          size: "85%",
          labels: {
            show: true,
            name: { show: true },
            value: {
              show: true,
              fontWeight: 700,
              fontSize: "16px",
              color: "#979797",
              formatter: function () {
                return "9.0";
              },
            },
            total: {
              show: true,
              showAlways: true,
              label: "9.0",
              fontSize: "48px",
              color: "#4D3280",
              formatter: function () {
                return "Financing Score";
              },
            },
          },
        },
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
        },
      },
    ],
    tooltip: {
      enabled: false,
    },
  };

  const financialScoreSeries = [90, 10]; // 90% filled → score 9.0 / 10

  return (
    <Card style={{ minWidth: 350 }}>
      <Flex vertical gap={30}>
        <Typography.Title level={4} style={{ marginBottom: 0 }}>
          Financial Score
        </Typography.Title>

        <Chart options={financialScoreOptions} series={financialScoreSeries} type="donut" width={280} height={230} />
      </Flex>
    </Card>
  );
}
